import {
  RENTAL_PORTAL_MOCK_COMPANY_FLAGS,
  RENTAL_PORTAL_MOCK_NO_CREATE_STATES,
  RENTAL_PORTAL_MOCK_STATE_ENABLED,
  RENTAL_PORTAL_MOCK_STATE_PARAM,
} from '../constants/rentalPortalMockState'

export function getRentalPortalMockCompanyFlags() {
  return { ...RENTAL_PORTAL_MOCK_COMPANY_FLAGS }
}

export function patchRentalPortalMockCompanyFlags(flags) {
  Object.assign(RENTAL_PORTAL_MOCK_COMPANY_FLAGS, flags)
}

export function getRentalPortalMockStates(search = window.location.search) {
  return new Set(
    RENTAL_PORTAL_MOCK_STATE_ENABLED
      ? new URLSearchParams(search)
          .get(RENTAL_PORTAL_MOCK_STATE_PARAM)
          ?.split(',')
          .map(state => state.trim())
      : null
  )
}

export function hasRentalPortalMockState(state, search) {
  return getRentalPortalMockStates(search).has(state)
}

export function getRentalPortalMockStateValue(prefix, search) {
  const state = [...getRentalPortalMockStates(search)].find(item =>
    item.startsWith(prefix)
  )

  return state ? state.slice(prefix.length) : null
}

export function hasRentalPortalMockCreateRight() {
  return !RENTAL_PORTAL_MOCK_NO_CREATE_STATES.some(state =>
    hasRentalPortalMockState(state)
  )
}
